import { Button } from '@/components/shadcn/button'
import { Badge } from '@/components/shadcn/badge'
import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { SpinnerIosRegular } from '@fluentui/react-icons'

type PodStatusResult = RestSchemas['Services.Support.PodStatusResult']

export function getPlatformContainersColumns(
  onViewLogs: (appName: string) => void,
  logsPending?: boolean,
  selectedAppName?: string | null
): ColumnDef<PodStatusResult>[] {
  return [
    {
      id: 'appName',
      accessorKey: 'appName',
      header: ({ column }) => <SortingHeaderButton column={column}>App</SortingHeaderButton>,
      cell: ({ cell }) => <span className="text-base">{(cell.getValue() as string) || ''}</span>,
      sortingFn: (rowA, rowB) => (rowA.original.appName || '').localeCompare(rowB.original.appName || ''),
      size: 220,
    },
    {
      id: 'containerID',
      accessorKey: 'containerID',
      header: ({ column }) => <SortingHeaderButton column={column}>Container ID</SortingHeaderButton>,
      cell: ({ cell }) => {
        const id = (cell.getValue() as string) || ''
        const shortId = id.length > 20 ? `${id.slice(0, 20)}…` : id
        return <span className="font-mono text-sm text-muted-foreground">{shortId}</span>
      },
      sortingFn: (rowA, rowB) => (rowA.original.containerID || '').localeCompare(rowB.original.containerID || ''),
      size: 240,
    },
    {
      id: 'containerStatus',
      accessorKey: 'containerStatus',
      header: ({ column }) => <SortingHeaderButton column={column}>Status</SortingHeaderButton>,
      cell: ({ cell }) => {
        const status = (cell.getValue() as string) || ''
        return (
          <Badge variant="secondary" className="h-5 w-fit font-normal">
            {status}
          </Badge>
        )
      },
      sortingFn: (rowA, rowB) =>
        (rowA.original.containerStatus || '').localeCompare(rowB.original.containerStatus || ''),
      size: 140,
    },
    {
      id: 'actions',
      header: '',
      cell: ({ row }) => (
        <div className="flex justify-end pr-5">
          <Button
            size="sm"
            variant="outline"
            disabled={!!logsPending}
            onClick={() => row.original.appName && onViewLogs(row.original.appName)}
          >
            {logsPending && selectedAppName === row.original.appName ? (
              <>
                <SpinnerIosRegular className="animate-spin" />
                Loading…
              </>
            ) : (
              'View Logs'
            )}
          </Button>
        </div>
      ),
      size: 140,
    },
  ]
}
